export const ariaLabel = {
  name: 'ariaLabel',
  friendlyName: 'Aria Label',
  type: 'string',
  helperText: 'The aria-label attribute for accessibility purposes.',
  regex: {
    pattern: '^[A-Za-z0-9\\s-]+$',
    options: '',
    message:
      'Please enter a valid aria-label. It should only contain letters, numbers, spaces, and hyphens.'
  }
};
